// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// view
import { Card, Badge } from "antd";
import Link from "next/link";
import UserLayout from "~/components/layout/UserLayout";
import UserProfileNavs from "~/components/users/UserProfileNavs";
import { showAppModal, setRedirect } from "~/redux/actions/app";
import { setUserInfo } from "~/redux/actions/user";

// utils
import _ from "lodash";
import { hasContactInfo } from "~/utils/user";
import { useEffect } from "react";

import { authUrlSilently, isWechatBrowser } from "~/utils/wechat";
import { useRouter } from "next/router";

const isWechat = isWechatBrowser();

const Page = (props) => {
  // props
  const { user } = props;

  const router = useRouter();
  const { redirectUrl } = router.query;

  useEffect(() => {
    let itsURL = window.location.href;
    if (new URL(itsURL).searchParams.get("ispaying") === "true" || !redirectUrl)
      return;
    let param = itsURL.indexOf("?") > 0 ? "&ispaying=true" : "?ispaying=true";
    window.location.href = authUrlSilently(itsURL + param);
  }, [redirectUrl]);

  const skillTypeTags = user
    ? _.filter(user.tags, (x) => x.tag_group.code === "skill_type")
    : "";
  const workTypeTags = user
    ? _.filter(user.tags, (x) => x.tag_group.code === "work_type")
    : "";

  // 初始化。
  useEffect(() => {
    if (isWechat) {
      let itsURL = new URL(window.location.href);
      if (itsURL.searchParams.get("ispaying") === "true") {
        props.setUserInfo({
          ...props.user,
          temp_code: itsURL.searchParams.get("code"),
        });
        props.showAppModal("TopUpModal");
      }
    }
  }, []);

  // views
  const renderValue = (value, render) => {
    let v = _.isString(value) ? _.trim(value) : value;

    if (_.isEmpty(v)) {
      return <span className="text-secondary">暂无</span>;
    } else {
      return render ? render(v) : v;
    }
  };
  const renderOpusLinks = (links) =>
    links.map((link, i) => (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        key={`${link}/${i}`}>
        {link}
      </a>
    ));
  const renderTags = (tags) => _.map(tags, "name").join("、");

  // 打开充值窗口。
  const openTopupModal = () => {
    if (isWechat) {
      if (!user.temp_code) {
        let itsURL = window.location.href;
        let tempCode = new URL(itsURL).searchParams.get("code");
        if (!tempCode) {
          let param =
            itsURL.indexOf("?") > 0 ? "&ispaying=true" : "?ispaying=true";
          return (window.location.href = authUrlSilently(itsURL + param));
        } else {
          props.setUserInfo({ ...props.user, temp_code: tempCode });
        }
      }
    }

    props.showAppModal("TopUpModal");
  };

  if (!user) {
    return;
  }

  return (
    <UserLayout
      pageTitle="查看个人资料"
      onClickCharge={openTopupModal}
      user={user}
      profile>
      <Card>
        <UserProfileNavs activeKey="info" />
        {user && (
          <table>
            <tbody>
              <tr>
                <th>
                  <div>昵称</div>
                </th>
                <td>{renderValue(user.nickname)}</td>
              </tr>
              <tr>
                <th>
                  <div>个人简介</div>
                </th>
                <td>{renderValue(user.tagline)}</td>
              </tr>
              <tr>
                <th>
                  <div>详细介绍</div>
                </th>
                <td>{renderValue(user.bio)}</td>
              </tr>
              <tr>
                <th>
                  <div>专业领域</div>
                </th>
                <td>{renderValue(skillTypeTags, renderTags)}</td>
              </tr>
              <tr>
                <th>
                  <div>职业身份</div>
                </th>
                <td>{renderValue(workTypeTags, renderTags)}</td>
              </tr>
              <tr>
                <th>
                  <div>目前职位</div>
                </th>
                <td>{renderValue(user.job_title)}</td>
              </tr>
              <tr>
                <th>
                  <div>所在城市</div>
                </th>
                <td>{renderValue(user.location)}</td>
              </tr>
              <tr>
                <th>
                  <div>个人性别</div>
                </th>
                <td>
                  {renderValue(user.gender, (v) =>
                    v === "male" ? "男" : "女"
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <Badge dot={!hasContactInfo(user)}>
                    <div>联系方式</div>
                  </Badge>
                </th>
                <td>{renderValue(user.contact_info)}</td>
              </tr>
              {/* <tr>
                  <th><div>作品链接</div></th>
                  <td>{renderValue(user.opus_links, renderOpusLinks)}</td>
                </tr> */}
              <tr>
                <th>
                  <Link legacyBehavior href="/profile/edit">
                    <a className="ant-btn ant-btn-primary ant-btn-lg">编辑</a>
                  </Link>
                </th>
              </tr>
            </tbody>
          </table>
        )}
      </Card>

      <style>
        {`
        table {
          margin: 10px;
        }

        table th div {
          width: 60px;
        }

        table th, table td {
          padding-top: 10px;
          padding-bottom: 10px;
        }

        table td {
          padding-left: 20px;
        }
      `}
      </style>
    </UserLayout>
  );
};

Page.requireUser = () => true;

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      setRedirect,
      setUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Page);
